import { gql } from "@apollo/client";

export const BANK_LINK_FRAGMENT = gql`
  fragment BankLinkFragment on BankLink {
    id
    status
    assets {
      name
      logo
    }
    providerInstitutionId
  }
`;

export const BANK_ACCOUNT_FRAGMENT = gql`
  fragment BankAccountFragment on BankAccount {
    id
    bankAccountId
    accountNumber
    routingNumber
    name
    useForBilling
    assetLogo
    assetColor
  }
`;
